
import { Component, Vue, Prop } from 'vue-property-decorator';
import { isInvalid, formatDate, isTrueArray, jumpWeb, jumpFenshi } from '@king-fisher/mobileweb-lib';
import { Tag, Icon } from '@atom/atom-ui';
import '@atom/atom-ui/es_750_rem/tag/style';
import '@atom/atom-ui/es_750_rem/icon/style';
import '@atom/atom-icons/icons/arrow-top';
import '@atom/atom-icons/icons/arrow-bottom';
import '@atom/atom-icons/icons/share-nav';
import { getAiContent } from '@/apis';
import { shareReport } from '@/utils/share';
import { AI_WORKFLOW_CONFIG } from '@/config/config';
import { statClick } from '@/config/stat';

export function getHotReports() {
  // 获取近一个月的热门研报
  const endDate = new Date();
  const startDate = new Date();
  const format = 'yyyyMMdd';
  const tagsLimit = 3;
  startDate.setMonth(endDate.getMonth() - 1);

  return getAiContent({
    workflow_id: AI_WORKFLOW_CONFIG.EXPLORE_REPORT_SUMMARY,
    start_date: formatDate(startDate, format),
    end_date: formatDate(endDate, format),
  }).then((res: any) => {
    if (res.statusCode !== 0 || !res.data || !isTrueArray(res.data.resultList)) {
      throw new Error('数据异常');
    }

    const list = res.data.resultList;
    // 按list每一项的referenceDate分组
    const grouped = list.reduce((acc: any, item: any) => {
      const date = item.referenceDate;
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    }, {});

    const formatShowDate = dateStr => {
      const currentYear = new Date().getFullYear().toString();
      const dateYear = dateStr.slice(0, 4);
      const month = dateStr.slice(4, 6);
      const day = dateStr.slice(6, 8);

      if (dateYear === currentYear) {
        return `${month}-${day}`;
      } else {
        return `${dateYear}-${month}-${day}`;
      }
    };

    // 转换为数组并按日期降序排序
    return Object.keys(grouped)
      .sort((a, b) => b.localeCompare(a))
      .map(date => ({
        formatDate: formatShowDate(date),
        items: grouped[date]
          .map(item => {
            const content = JSON.parse(item.content);
            const data = content.report_data;
            return {
              symbol: item.symbol,
              formatDate: formatShowDate(date),
              reference_date: data.reference_date,
              name: data.stock_name || '--',
              code: data.stock_code,
              market: data.stock_market,
              title: data.title || '--',
              url: data.url,
              condition: (data.condition || []).slice(0, tagsLimit),
              summary: data.summary,
            };
          })
          .reverse(),
      }));
  });
}

@Component({
  components: {
    [Tag.name]: Tag,
    [Icon.name]: Icon,
  },
})
export default class ExploreReportList extends Vue {
  @Prop({ default: false }) private enableClamp: boolean;
  @Prop({ default: 0 }) private index: number;
  @Prop({ default: [] }) private list: any[];

  private localList: any[] = [];

  created() {
    this.initLocalList();
    this.$watch('list', this.initLocalList, { deep: true, immediate: true });
  }

  private initLocalList() {
    if (isTrueArray(this.list)) {
      const needClamp = this.enableClamp && this.index == 0;
      this.localList = this.list.map((item, index) => ({ ...item, clamp: needClamp && index !== 0 }));
    } else {
      this.localList = [];
    }
  }

  get formattedList() {
    return this.localList;
  }

  handleItemClamp(item) {
    this.$set(item, 'clamp', !item.clamp);
  }

  handleShare(item) {
    shareReport({
      list: [item],
      publicTime: `研报机会挖掘 ${item.formatDate}`,
    });
  }

  handleNameClick(item) {
    statClick('ths_mob_yanbao_pagetop_gofenshi');

    jumpFenshi(item.code, item.market);
  }

  jumpToReport(url) {
    statClick('ths_mob_yanbao_pagetop_dianjiyanbao');

    if (isInvalid(url)) {
      return;
    }
    jumpWeb(url);
  }
}
